import z from 'zod'
import {type User, userSchema, baseUserSchema} from './types/users.types'
import {REST} from '@/api'
import type {AxiosResponse} from 'axios'

const USERS_URL = '/api/v1/users'

export async function fetchUsers(): Promise<User[]> {
    const res = await fetchRawUsers()
    return parseBody(res, z.array(userSchema))
}

async function fetchRawUsers() {
    try {
        return await REST.get(USERS_URL)
    } catch (error) {
        throw new Error(
            `Failed to fetch users: ${error instanceof Error ? error.message : String(error)}`,
        )
    }
}

function parseBody<T extends z.ZodType>(response: AxiosResponse, schema: T) {
    try {
        return schema.parse(response.data)
    } catch (error) {
        throw new Error(
            `Invalid response body format: ${error instanceof Error ? error.message : String(error)}`,
        )
    }
}

export async function fetchBaseUsers() {
    const res = await fetchRawUsers()
    return parseBody(res, z.array(baseUserSchema))
}

export async function fetchCurrentUser(): Promise<User> {
    try {
        const res = await REST.get<unknown>(`${USERS_URL}/current`)
        return userSchema.parse(res.data)
    } catch (error) {
        if (error instanceof z.ZodError) {
            throw new Error(`Invalid user data format: ${error.message}`)
        }
        throw new Error(
            `Failed to fetch current user: ${error instanceof Error ? error.message : String(error)}`,
        )
    }
}
